import React from 'react'
import UnifiedSponsorsSection from '../components/UnifiedSponsorsSection'

export default function SponsersPage() {
  return (
    <UnifiedSponsorsSection 
      fetchId={process.env.REACT_APP_HOME_PAGE_SPONSERS_POST_ID}
      sectionId="sponsors"
      translationKey="web.sponsors"
      defaultTitle="Sponsors"
    />
  )
}
